export const SuccesModalConsts = {
    HEADER: "Success",
    getMessage: (ticketCount:number) => `${ticketCount > 1 ? "Invoices are" : "Invoice is"} getting generated. It may take some time depending on the number of invoices`,
    GO_TO_INVOICE_MANAGEMENT: "Go to Invoice Management",
    BUTTON_CLASS: "actionButtonClass",
}